import React, { PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Logo } from 'components/_new/Logo';
import { Box, BoxSection } from './_new/Box';

type PageInfoProps = PropsWithChildren<{
	message?: string;
	debug?: string;
	linkTo?: string;
	linkLabel?: string;
}>;

export const PageInfo = ({ message, debug, children, linkTo, linkLabel }: PageInfoProps) => {
	const { t } = useTranslation();

	return (
		<div className="flex flex-column align-items-center justify-content-center row-gap-6 pt-8 pb-7 w-full px-3">
			<Box variant="white" dropShadow className="w-full" style={{ maxWidth: '480px' }}>
				<BoxSection className="px-4 sm:px-6 py-4 text-center" contentClassName="w-full">
					<Logo size="xl" className="mt-2 mb-6 align-self-center" />
					{message ? <p>{message}</p> : children}
					<Link to={{ pathname: linkTo || '/' }} className="p-link underline text-center">
						{linkLabel || t('misc.buttons.backToMainPage')}
					</Link>
					{debug && process.env.NODE_ENV === 'development' && <h1>{debug}</h1>}
				</BoxSection>
			</Box>
		</div>
	);
};
